export const FIRST_NAME = 'First Name';
export const LAST_NAME = 'Last Name';
export const EMAIL = 'Email';
export const PHONE = 'Phone';
export const DATE_OF_BIRTH = 'Date of Birth';
export const SAVE = 'Save';
export const CANCEL = 'Cancel';

export const firstname = 'firstname';
export const lastname = 'lastname';
export const email = 'email';
export const phone = 'phone';
export const birthdate = 'birthdate';

export const messages = {
  firstNameRequired: 'First Name is required',
  lastNameRequired: 'Last Name is required',
  phoneNumberRequired: 'Phone Number is required',
  phoneNumberValid: 'Please Enter a valid Phone Number',
  ageRequirement: 'You must be at least 18',
  birthdayRequired: 'Birth Date is required',
};
